import { createSlice } from '@reduxjs/toolkit';
import { createMatcher } from '~/utils/create-action/create-matcher';
import { defaultState } from './data/AssetTagRelationshipsState';
import AssetTagRelationshipsConstants from './constants';

const slice = createSlice({
  name: 'asset-tag-relationships',
  initialState: defaultState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      createMatcher([
        AssetTagRelationshipsConstants.ADD_ASSET_TAG_RELATIONSHIPS_REQUEST,
        AssetTagRelationshipsConstants.REMOVE_ASSET_TAG_RELATIONSHIPS_REQUEST,
      ]),
      (state) => {
        state.isLoading = true;
      }
    );
    builder.addMatcher(
      createMatcher([
        AssetTagRelationshipsConstants.ADD_ASSET_TAG_RELATIONSHIPS_REQUEST_SUCCESS,
        AssetTagRelationshipsConstants.ADD_ASSET_TAG_RELATIONSHIPS_REQUEST_ERROR,
        AssetTagRelationshipsConstants.REMOVE_ASSET_TAG_RELATIONSHIPS_REQUEST_SUCCESS,
        AssetTagRelationshipsConstants.REMOVE_ASSET_TAG_RELATIONSHIPS_REQUEST_ERROR,
      ]),
      (state) => {
        state.isLoading = false;
      }
    );
  },
});

export default slice.reducer;
